<template>
  <div>
    <SearchAndFilter v-model="queryString" />
    <ContentSectionLoader v-show="!loaded" />
    <div v-show="loaded" class="mt-4">
      <CardView
        v-if="cardView"
        :memberships="memberships.data"
      />
      <TableView
        v-if="tableView"
        :memberships="memberships.data"
      />
      <Pagination
        v-if="loaded"
        :pagination="memberships.meta.pagination"
      />
    </div>
  </div>
</template>

<script type="text/babel">
import URI from 'urijs'
import Pagination from 'Base/Resources/assets/js/components/Pagination'
import CardView from 'Membership/Resources/assets/js/components/MembershipsCardView'
import TableView from 'Membership/Resources/assets/js/components/MembershipsTableView'
import SearchAndFilter from 'Membership/Resources/assets/js/components/SearchAndFilter'

export default {
  name: 'Memberships',
  components: {
    CardView,
    TableView,
    Pagination,
    SearchAndFilter,
  },
  data() {
    return {
      queryString: {
        query: '',
        page: 1,
        filter: 'all',
        include: 'membershipGroups',
      },
      loaded: false,
      memberships: {
        data: [],
        meta: {
          pagination: {},
        },
      },
    }
  },
  computed: {
    cardView() {
      return this.$root.memberIndexView === 'card'
    },
    tableView() {
      if (!this.$root.userCan('edit-membership-groups') && this.$root.memberIndexView === 'list') {
        this.$root.setMemberIndexView('card')
      }

      return this.$root.memberIndexView === 'list'
    },
    fetchUrl() {
      return new URI('').setSearch(this.queryString).toString()
    },
  },
  watch: {
    queryString: {
      handler: _.debounce(function () {
        history.pushState(null, null, this.fetchUrl)

        this.fetch()
      }, 500),
      deep: true,
    },
  },
  async mounted() {
    await this.$nextTick()

    this.queryString = Object.assign(this.queryString, new URI().query(true))

    this.fetch()
  },
  methods: {
    fetch() {
      this.loaded = false

      this.$api.active().get(`memberships/${this.fetchUrl}`)
        .then((response) => {
          this.memberships = response.data
          this.loaded = true
        })
    },
  },
}
</script>
